/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class Account {
    constructor(data) {
        if (data) {
            Object.assign(this, data);
        } else {
            this.profileIds = [];
            this.accessProfileIds = [];
        }
    }
}

export { Account };



// WEBPACK FOOTER //
// ./src/main/front/scripts/model/Account.js